import { render, staticRenderFns } from "./PerfSumPage.vue?vue&type=template&id=ec1a83a0"
import script from "./PerfSumPage.vue?vue&type=script&lang=js"
export * from "./PerfSumPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports